// src/components/SectorExposure.jsx
// 섹터별(WICS) 롱/숏 비중 — 그로스 대비 %. 숏=좌(빨강)·롱=우(초록) 다이버징 바.
import React from "react";
import { portfolioExposure } from "../lib/exposure";
import { sectorOf } from "../lib/sectors";

const LONG = "#0a7c59", SHORT = "#c0392b";

export default function SectorExposure({ holdings, marketData, exchangeRates }) {
  const { rows, grossKRW } = portfolioExposure(holdings, marketData, exchangeRates);

  const bySector = {};
  rows.filter((r) => r.hasPrice).forEach((r) => {
    const sec = sectorOf(r.ticker, r.market);
    const b = bySector[sec] || (bySector[sec] = { longKRW: 0, shortKRW: 0 });
    if (r.short) b.shortKRW += Math.abs(r.signedKRW);
    else b.longKRW += Math.abs(r.signedKRW);
  });

  const data = Object.entries(bySector)
    .map(([sector, v]) => ({
      sector,
      longPct: grossKRW ? (v.longKRW / grossKRW) * 100 : 0,
      shortPct: grossKRW ? (v.shortKRW / grossKRW) * 100 : 0,
    }))
    .sort((a, b) => (b.longPct + b.shortPct) - (a.longPct + a.shortPct));

  // 바 스케일: 한 사이드 최대 비중을 반폭에 매핑
  const maxSide = Math.max(1, ...data.map((d) => Math.max(d.longPct, d.shortPct)));

  return (
    <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: 12, padding: 20, marginTop: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: "#1a1a2e" }}>섹터별 롱/숏 비중</h3>
        <div style={{ fontSize: 10, color: "#aaa" }}>
          <span style={{ color: SHORT }}>■</span> 숏 &nbsp; <span style={{ color: LONG }}>■</span> 롱 &nbsp;(그로스 대비)
        </div>
      </div>

      {data.length === 0 ? (
        <div style={{ textAlign: "center", color: "#aaa", padding: 24 }}>데이터 없음</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {data.map((d) => (
            <div key={d.sector} style={{ display: "grid", gridTemplateColumns: "68px 1fr", alignItems: "center", gap: 8 }}>
              <div style={{ fontSize: 10.5, color: "#555", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={d.sector}>
                {d.sector}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* 숏(좌) */}
                <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                  {d.shortPct > 0 && (
                    <div style={{ position: "relative", width: `${(d.shortPct / maxSide) * 100}%`, height: 16, background: SHORT, borderRadius: "3px 0 0 3px", minWidth: 2 }}>
                      <span style={pctLabel("right")}>{d.shortPct.toFixed(1)}</span>
                    </div>
                  )}
                </div>
                <div style={{ width: 1, height: 18, background: "#ccc" }} />
                {/* 롱(우) */}
                <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
                  {d.longPct > 0 && (
                    <div style={{ position: "relative", width: `${(d.longPct / maxSide) * 100}%`, height: 16, background: LONG, borderRadius: "0 3px 3px 0", minWidth: 2 }}>
                      <span style={pctLabel("left")}>{d.longPct.toFixed(1)}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function pctLabel(side) {
  return {
    position: "absolute", top: "50%", transform: "translateY(-50%)",
    [side === "right" ? "right" : "left"]: "calc(100% + 3px)",
    fontSize: 9.5, color: "#888", whiteSpace: "nowrap",
  };
}
